module.exports = __webpack_public_path__ + "img/bsa2.76aef648.png";